import { render, staticRenderFns } from "./main.vue?vue&type=template&id=2c4a8378"
var script = {}
import style0 from "./main.vue?vue&type=style&index=0&id=2c4a8378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports